<template>
  <div class="page-container">
    <div class="head" v-if="!embedded">
      <div class="head-title">
        <img src="../../static/img/logo.png" class="head-logo" />
        景区旅游大数据中心      </div>
      <div class="head-type">
        <div
          class="type-item"
          v-for="(item, index) in navItems"
          :key="index"
          :class="{ 'type-item2': index === activeNavIndex }"
          @click="typeChange(item)"
        >
          {{ item.label }}
          <div class="type-on" v-if="index === activeNavIndex"></div>
        </div>
      </div>
      <div>
        <div class="date-weather">
          <div class="changeDateOne" @click="changeTheDate(-1)">前一天</div>
          <div class="changeDateOne" @click="changeTheDate(0)">&nbsp;&nbsp;</div>
          <div class="changeDateOne" @click="changeTheDate(1)">后一天</div>
          <img
            @click="refreshPage"
            src="../../static/img/refresh-ccw.png"
            style="
              display: inline-block;
              width: 14px;
              height: 14px;
              vertical-align: middle;
              transform: translate(0, -2px);
              cursor: pointer;
            "
            v-if="isToday"
          />
          {{ isToday ? nowDay : req_date.replace('-', '/') }} {{ isToday ? week : changeWeek }} {{ isToday ? nowTime : '' }}
        </div>
      </div>
    </div>

    <div class="warning-main" :class="{ 'embedded-mode': embedded }">
      <div :id="mapId" class="migrateMap"></div>
      <div class="warning-left">
        <div class="data-box warning-panel sentiment-panel sentiment-panel-pie">
          <div class="warning-panel-title">舆情统计</div>
          <div id="sentimentPieChart" class="sentiment-chart"></div>
          <div class="sentiment-keywords">
            <div class="sentiment-keywords-title">7天内负面舆情关键词前4:</div>
            <div class="sentiment-keywords-grid">
              <div class="sentiment-keyword-item" v-for="(item, index) in negativeKeywords.slice(0, 4)" :key="index">
                <span class="keyword-label" :title="item.keyword.split('||').join(' ')">{{ item.keyword.split('||').join(' ') }}</span>
                <span class="keyword-count">{{ item.count }}条</span>
              </div>
              <div v-if="negativeKeywords.length === 0" class="no-data">暂无数据</div>
            </div>
          </div>
        </div>

        <div class="data-box warning-panel sentiment-panel sentiment-panel-bar">
          <div class="warning-panel-title">舆情来源渠道</div>
          <div id="sentimentBarChart" class="sentiment-chart"></div>
        </div>

        <div class="data-box warning-panel sentiment-panel sentiment-panel-keyword">
          <div class="warning-panel-title keyword-panel-title">
            关键词管理            <button class="keyword-edit-btn" @click="openPlanModal()">修改方案</button>
          </div>
          <div class="keyword-table-container">
            <div class="keyword-table">
              <div class="keyword-row" v-for="(plan, index) in planList.filter(p => p.status === 'running')" :key="index" :class="{ 'clickable': true }" @click="openKeywordModal(plan.id)">
                <span class="keyword-tag">{{ plan.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="warning-right">
        <!-- 舆情列表 -->
        <div class="data-box warning-panel">
          <div class="panel-title">舆情列表</div>
          <div class="sentiment-list" ref="sentimentList">
            <div class="sentiment-item" v-for="(item, index) in sentimentList" :key="'sentiment-' + index" @click="openSentimentDetail(item)">
              <div class="sentiment-row">
                <span class="sentiment-title">{{ item.title }}</span>
                <span class="sentiment-source">{{ item.source }}</span>
              </div>
              <div class="sentiment-info">
                <span class="sentiment-tag" :class="'sentiment-' + item.sentiment">{{ item.sentiment_display }}</span>
                <span class="sentiment-time">{{ item.publishTime }}</span>
              </div>
            </div>
            <div v-if="sentimentList.length === 0" class="no-data">暂无数据</div>
          </div>
        </div>

        <!-- 预警工单 -->
        <div class="data-box warning-panel">
          <div class="panel-title">
            <span>预警工单</span>
            <span v-if="pendingWarningCount > 0" class="title-badge">{{ pendingWarningCount }}</span>
          </div>
          <div class="supervision-warning-list" ref="supervisionWarningList">
            <div class="supervision-warning-item" v-for="(item, index) in supervisionWarningList" :key="'warning-' + index" :class="{ 'negative-warning': item.isNegative }" @click="openSentimentDetail(item)">
              <div class="supervision-warning-header">
                <span class="warning-id">{{ item.id }}</span>
                <span class="warning-status" :class="'status-' + item.status">{{ item.status }}</span>
              </div>
              <div class="supervision-warning-content">{{ item.content }}</div>
              <div class="supervision-warning-footer">
                <span class="warning-type" :class="{ 'negative-type': item.isNegative }">{{ item.type }}</span>
                <span class="warning-party">{{ item.responsibleParty }}</span>
              </div>
              <div v-if="item.isNegative && item.status === '待受理'" class="warning-actions">
                <button class="generate-workorder-btn" @click.stop="generateWorkOrder(index)">生成处置工单</button>
              </div>
            </div>
            <div v-if="supervisionWarningList.length === 0" class="no-data">暂无数据</div>
          </div>
          <div class="export-button-container">
            <button class="export-button" @click="openExportModal">导出台账</button>
          </div>
        </div>
      </div>

      <div class="export-modal" v-if="exportModalVisible">
        <div class="export-modal-mask" @click="closeExportModal"></div>
        <div class="export-modal-dialog data-box">
          <div class="export-modal-header">
            <div class="export-modal-title">导出台账</div>
            <div class="export-modal-close" @click="closeExportModal">×</div>
          </div>
          <div class="export-modal-body">
            <div class="export-form-item">
              <label class="export-form-label">时间范围：</label>
              <div class="export-date-range">
                <input type="date" v-model="exportForm.startDate" class="export-date-input">
                <span class="date-separator">至</span>
                <input type="date" v-model="exportForm.endDate" class="export-date-input">
              </div>
            </div>
            <div class="export-form-item">
              <label class="export-form-label">舆情类型：</label>
              <select v-model="exportForm.type" class="export-select">
                <option value="">全部</option>
                <option value="投诉">投诉</option>
                <option value="舆情">舆情</option>
                <option value="负面">负面</option>
                <option value="正面报道">正面报道</option>
                <option value="公告">公告</option>
              </select>
            </div>
            <div class="export-form-item">
              <label class="export-form-label">处理状态：</label>
              <select v-model="exportForm.status" class="export-select">
                <option value="">全部</option>
                <option value="待受理">待受理</option>
                <option value="处理中">处理中</option>
                <option value="已办结">已办结</option>
              </select>
            </div>
            <div class="export-form-item">
              <label class="export-form-label">责任主体：</label>
              <select v-model="exportForm.responsibleParty" class="export-select">
                <option value="">全部</option>
                <option v-for="party in responsibleParties" :key="party" :value="party">{{ party }}</option>
              </select>
            </div>
          </div>
          <div class="export-modal-footer">
            <button class="export-modal-cancel-btn" @click="closeExportModal">取消</button>
            <button class="export-modal-confirm-btn" @click="exportWorkOrder">导出</button>
          </div>
        </div>
      </div>

      <!-- 监控订阅方案编辑弹窗 -->
      <div class="plan-modal" v-if="planModalVisible">
        <div class="plan-modal-mask" @click="closePlanModal"></div>
        <div class="plan-modal-dialog data-box">
          <div class="plan-modal-header">
            <div class="plan-modal-title">监控订阅方案管理</div>
            <div class="plan-modal-close" @click="closePlanModal">×</div>
          </div>
          <div class="plan-modal-body">
            <div class="plan-modal-toolbar">
              <button class="plan-add-btn" @click="openPlanFormModal()">新增方案</button>
            </div>
            <div class="plan-table-container">
              <div class="plan-table-header">
                <span>方案名称</span>
                <span>监控状态</span>
                <span>创建时间</span>
                <span>更新时间</span>
                <span>操作</span>
              </div>
              <div class="plan-table-body">
                <div class="plan-table-row" v-for="plan in planList" :key="plan.id">
                  <span class="plan-table-name">{{ plan.name }}</span>
                  <span class="plan-table-status" :class="{ 'status-running': plan.status === 'running' }">{{ plan.statusDisplay }}</span>
                  <span class="plan-table-time">{{ plan.createTime }}</span>
                  <span class="plan-table-time">{{ plan.updateTime }}</span>
                  <span class="plan-table-actions">
                    <a href="javascript:void(0)" @click="openPlanFormModal(plan)">编辑</a>
                    <a href="javascript:void(0)" @click="openKeywordModal()">关键词管理</a>
                    <a href="javascript:void(0)" @click="deletePlan(plan.id)">删除</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="plan-modal-footer">
            <button class="plan-modal-cancel-btn" @click="closePlanModal">关闭</button>
          </div>
        </div>
      </div>

      <!-- 监控订阅方案表单弹窗 -->
      <div class="plan-form-modal" v-if="planFormModalVisible">
        <div class="plan-form-modal-mask" @click="closePlanFormModal"></div>
        <div class="plan-form-modal-dialog data-box">
          <div class="plan-form-modal-header">
            <div class="plan-form-modal-title">{{ editingPlan.id ? '编辑监控方案' : '新增监控方案' }}</div>
            <div class="plan-form-modal-close" @click="closePlanFormModal">×</div>
          </div>
          <div class="plan-form-modal-body">
            <div class="plan-form-item">
              <label>方案名称</label>
              <input type="text" v-model="editingPlan.name" class="plan-form-input" placeholder="请输入方案名称">
            </div>
            <div class="plan-form-item">
              <label>方案状态</label>
              <select v-model="editingPlan.status" class="plan-form-select">
                <option value="running">运行中</option>
                <option value="stopped">已停止</option>
              </select>
            </div>
          </div>
          <div class="plan-form-modal-footer">
            <button class="plan-form-modal-cancel-btn" @click="closePlanFormModal">取消</button>
            <button class="plan-form-modal-save-btn" @click="savePlan">保存</button>
          </div>
        </div>
      </div>

      <div class="keyword-modal" v-if="keywordModalVisible">
        <div class="keyword-modal-mask" @click="closeKeywordModal"></div>
        <div class="keyword-modal-dialog data-box">
          <div class="keyword-modal-header">
            <div class="keyword-modal-title">监控订阅方案配置</div>
            <div class="keyword-modal-close" @click="closeKeywordModal">×</div>
          </div>
          <div class="keyword-modal-body">
            <div class="monitor-plan-info">
              <div class="plan-info-item">
                <span class="plan-info-label">方案名称：</span>
                <span class="plan-info-value">{{ currentPlan.name }}</span>
              </div>
              <div class="plan-info-item">
                <span class="plan-info-label">监控状态：</span>
                <span class="plan-info-value plan-status" :class="{ 'active': currentPlan.status === 'running' }">{{ currentPlan.statusDisplay }}</span>
              </div>
              <div class="plan-info-item">
                <span class="plan-info-label">关键词数量：</span>
                <span class="plan-info-value" style="cursor: pointer; text-decoration: underline;" @click="openNegativeKeywordModal">{{ currentPlanKeywords.length }} 个</span>
              </div>
            </div>
            <div class="keyword-modal-table-header">
              <span>监控关键词</span>
              <span>监控状态</span>
              <span>操作</span>
            </div>
            <div class="keyword-modal-table-scroll">
              <div class="keyword-modal-table-body">
                <div class="keyword-modal-table-row" v-for="(item, index) in currentPlanKeywords" :key="index" :class="{ 'keyword-disabled': !item.enabled }">
                  <span>{{ item.name }}</span>
                  <span>
                    <span class="switch-track" :class="{ 'switch-on': item.enabled }" @click.stop="toggleKeywordEnabled(index)">
                      <span class="switch-thumb" :class="{ 'switch-thumb-on': item.enabled }"></span>
                    </span>
                  </span>
                  <span class="keyword-modal-table-actions">
                    <a href="javascript:void(0)" @click="editKeyword(index)">编辑</a>
                    <a href="javascript:void(0)" @click="deleteKeyword(index)">删除</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="keyword-modal-footer">
            <button class="keyword-modal-import-btn" @click="openBatchImportModal">批量导入关键词</button>
            <button class="keyword-modal-add-btn" @click="addKeyword">新增关键词</button>
          </div>
        </div>
      </div>

      <div class="keyword-batch-import-modal" v-if="batchImportModalVisible">
        <div class="keyword-batch-import-modal-mask" @click="closeBatchImportModal"></div>
        <div class="keyword-batch-import-modal-dialog data-box">
          <div class="keyword-batch-import-modal-header">
            <div class="keyword-batch-import-modal-title">批量导入关键词</div>
            <div class="keyword-batch-import-modal-close" @click="closeBatchImportModal">×</div>
          </div>
          <div class="keyword-batch-import-modal-body">
            <div class="batch-import-tip">请输入关键词，多个关键词用逗号分隔</div>
            <textarea v-model="batchImportText" class="batch-import-textarea" placeholder="例如：&#10;婺源,旅游,景区,民宿,美食"></textarea>
          </div>
          <div class="keyword-batch-import-modal-footer">
            <button class="keyword-batch-import-modal-cancel-btn" @click="closeBatchImportModal">取消</button>
            <button class="keyword-batch-import-modal-confirm-btn" @click="confirmBatchImport">确定</button>
          </div>
        </div>
      </div>

      <div class="negative-keyword-modal" v-if="negativeKeywordModalVisible">
        <div class="negative-keyword-modal-mask" @click="closeNegativeKeywordModal"></div>
        <div class="negative-keyword-modal-dialog data-box">
          <div class="negative-keyword-modal-header">
            <div class="negative-keyword-modal-title">关键词列表</div>
            <div class="negative-keyword-modal-close" @click="closeNegativeKeywordModal">×</div>
          </div>
          <div class="negative-keyword-modal-body">
            <div class="negative-keyword-list">
              <span v-for="(keyword, index) in currentPlanKeywords" :key="index" class="negative-keyword-item">
                {{ keyword.name }}
              </span>
            </div>
          </div>
          <div class="negative-keyword-modal-footer">
            <button class="negative-keyword-modal-close-btn" @click="closeNegativeKeywordModal">关闭</button>
          </div>
        </div>
      </div>

      <div class="confirm-modal" v-if="confirmModalVisible">
        <div class="confirm-modal-mask" @click="closeConfirmModal"></div>
        <div class="confirm-modal-dialog data-box">
          <div class="confirm-modal-header">
            <div class="confirm-modal-title">确认生成工单</div>
            <div class="confirm-modal-close" @click="closeConfirmModal">×</div>
          </div>
          <div class="confirm-modal-body">
            <div class="confirm-modal-info">
              <div class="confirm-info-item">
                <span class="confirm-info-label">工单编号：</span>
                <span class="confirm-info-value">{{ confirmModalData.id }}</span>
              </div>
              <div class="confirm-info-item">
                <span class="confirm-info-label">舆情内容：</span>
                <span class="confirm-info-value">{{ confirmModalData.content }}</span>
              </div>
              <div class="confirm-info-item">
                <span class="confirm-info-label">派发至：</span>
                <select v-model="confirmModalData.selectedParty" class="confirm-select">
                  <option v-for="party in responsibleParties" :key="party" :value="party">{{ party }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="confirm-modal-footer">
            <button class="confirm-modal-cancel-btn" @click="closeConfirmModal">取消</button>
            <button class="confirm-modal-confirm-btn" @click="confirmGenerateWorkOrder">确定派发</button>
          </div>
        </div>
      </div>

      <div class="tip-modal" v-if="tipModalVisible">
        <div class="tip-modal-mask" @click="closeTipModal"></div>
        <div class="tip-modal-dialog data-box">
          <div class="tip-modal-header">
            <div class="tip-modal-title">提示</div>
            <div class="tip-modal-close" @click="closeTipModal">×</div>
          </div>
          <div class="tip-modal-body">
            <div class="tip-modal-message">{{ tipModalMessage }}</div>
          </div>
          <div class="tip-modal-footer">
            <button class="tip-modal-confirm-btn" @click="closeTipModal">确定</button>
          </div>
        </div>
      </div>

      <div class="keyword-edit-modal" v-if="keywordEditModalVisible">
        <div class="keyword-edit-modal-mask" @click="closeKeywordEditModal"></div>
        <div class="keyword-edit-modal-dialog data-box">
          <div class="keyword-edit-modal-header">
            <div class="keyword-edit-modal-title">{{ editingKeywordIndex === -1 ? '新增关键词' : '编辑关键词' }}</div>
            <div class="keyword-edit-modal-close" @click="closeKeywordEditModal">×</div>
          </div>
          <div class="keyword-edit-modal-body">
            <div class="keyword-edit-form-item">
              <label>关键词</label>
              <input type="text" v-model="editingKeyword.name" class="keyword-edit-input" placeholder="请输入关键词">
            </div>
          </div>
          <div class="keyword-edit-modal-footer">
            <button class="keyword-edit-modal-cancel-btn" @click="closeKeywordEditModal">取消</button>
            <button class="keyword-edit-modal-confirm-btn" @click="saveKeyword">确定</button>
          </div>
        </div>
      </div>

      <div class="sentiment-detail-panel" v-if="sentimentDetailModalVisible">
        <div class="sentiment-detail-panel-dialog data-box">
          <div class="sentiment-detail-panel-header">
            <div class="sentiment-detail-panel-title">舆情详情</div>
            <div class="sentiment-detail-panel-close" @click="closeSentimentDetailModal">×</div>
          </div>
          <div class="sentiment-detail-panel-body">
            <div class="sentiment-detail-header">
              <div class="sentiment-detail-title">{{ currentSentimentDetail.title }}</div>
            </div>
            <div class="sentiment-detail-info">
              <span class="info-item"><span class="info-label">来源：</span>{{ currentSentimentDetail.source }}</span>
              <span class="info-item"><span class="info-label">发布时间：</span>{{ currentSentimentDetail.publishTime }}</span>
              <span class="info-item"><span class="info-label">情感类型：</span>{{ currentSentimentDetail.sentiment_display }}</span>
              <span class="info-item"><span class="info-label">转发数：</span>{{ currentSentimentDetail.forwardCount || 0 }}</span>
              <span class="info-item"><span class="info-label">点赞数：</span>{{ currentSentimentDetail.likeCount || 0 }}</span>
              <span class="info-item"><span class="info-label">评论数：</span>{{ currentSentimentDetail.commentCount || 0 }}</span>
            </div>
            <div class="sentiment-detail-url" v-if="currentSentimentDetail.url">
              <span class="url-label">原文链接：</span>
              <a :href="currentSentimentDetail.url" target="_blank" class="url-link">{{ currentSentimentDetail.url }}</a>
            </div>
            <div class="sentiment-detail-propagation">
              <button class="propagation-btn" @click="openPropagationModal(currentSentimentDetail)">查看传播链路</button>
            </div>
            <div class="sentiment-detail-content">
              <div class="content-label">内容：</div>
              <div class="content-text" v-html="currentSentimentDetail.content"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 传播链路弹窗 -->
      <div class="propagation-modal" v-if="propagationModalVisible">
        <div class="propagation-modal-mask" @click="closePropagationModal"></div>
        <div class="propagation-modal-dialog data-box">
          <div class="propagation-modal-header">
            <div class="propagation-modal-title">传播链路</div>
            <div class="propagation-modal-close" @click="closePropagationModal">×</div>
          </div>
          <div class="propagation-modal-body">
            <div class="propagation-list">
              <div class="propagation-item-wrapper" v-for="(item, index) in propagationListData" :key="index">
                <div class="propagation-item">
                  <div class="propagation-content">
                    <div class="propagation-type">
                      <span class="type-label" :class="'type-' + item.type">{{ item.typeDisplay }}</span>
                    </div>
                    <div class="propagation-info">
                      <span class="info-source">{{ item.source }}</span>
                      <span class="info-date">{{ item.publishTime }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="index === 0 || (index < propagationListData.length - 1 && propagationListData[index + 1].type === 'original')" class="arrow-separator">↓</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import store from '@/store/index'
import { getSettingByIdApi } from '../api/ScenicAPI'
import {
  sentimentOverviewData,
  sentimentArticlesData,
  sentimentKeywordsData,
  sentimentSourcesData,
  sentimentWarningsData,
  sentimentWarningsHandleData
} from '../api/wuyuanApi'

const WUYUAN_CENTER = {
  lat: 29.254015,
  lng: 117.861488
}

const WUYUAN_BOUNDARY_LOCAL_URL = process.env.NODE_ENV === 'production'
  ? '/static/big_data_web/geo/361130.json'
  : '/static/geo/361130.json'
const WUYUAN_BOUNDARY_REMOTE_URL = 'https://geo.datav.aliyun.com/areas_v3/bound/361130.json'
const WUYUAN_BOUNDARY_URLS = [WUYUAN_BOUNDARY_LOCAL_URL, WUYUAN_BOUNDARY_REMOTE_URL]
const WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO = 0.38
const WUYUAN_VIEW_VERTICAL_PADDING_RATIO = 0.18

export default {
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      navItems: [
        { label: '文旅市场', path: '/', query: { typeIndex: 0 } },
        { label: '客流分析', path: '/scenic_date_data', query: { typeIndex: 0 } },
        { label: '大数据驾驶舱', path: '/', query: { typeIndex: 2 } },
        { label: '客流预警', path: '/scenic_warning', query: {} }
      ],
      activeNavIndex: 3,
      scenic_id: '',
      req_date: null,
      isToday: true,
      nowDay: '',
      nowDay2: '',
      nowTime: '',
      week: '',
      changeWeek: '',
      hour: '',
      weather: {},
      warningRecordCount: 10,
      recordVisible: true,

      mapId: 'sentimentMap',
      setting: {
        map_show: 5,
        lat_offset: 0,
        lng_offset: 0
      },
      map: null,
      boundaryLayer: null,
      boundaryGeometries: [],
      boundaryBounds: null,
      viewportBounds: null,
      
      clockTimer: null,
      pieChart: null,
      barChart: null,
      sentimentPieData: [
        { value: 65, name: '正面', itemStyle: { color: '#00D4AA' } },
        { value: 22, name: '中性', itemStyle: { color: '#5589F2' } },
        { value: 13, name: '负面', itemStyle: { color: '#E53F31' } }
      ],
      sentimentBarData: [
        { name: '新闻', value: 45 },
        { name: '社交', value: 78 },
        { name: '视频', value: 32 },
        { name: '投诉', value: 28 },
        { name: '评论', value: 56 },
        { name: '论坛', value: 18 }
      ],
      negativeKeywords: [],
      currentPlanId: 1,
      // 监控订阅方案数据
      planList: [
        {
          id: 1,
          name: '婺源景区舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-01 09:00:00',
          updateTime: '2026-06-08 10:30:00',
          keywords: [
            { name: '票价贵', count: '123,456', enabled: true },
            { name: '拥挤', count: '98,765', enabled: true },
            { name: '管理混乱', count: '87,654', enabled: true },
            { name: '周边堵车', count: '76,543', enabled: true },
            { name: '秩序混乱', count: '65,432', enabled: true },
            { name: '过度商业化', count: '54,321', enabled: true },
            { name: '同质化严重', count: '43,210', enabled: true },
            { name: '缺乏创新', count: '32,109', enabled: true },
            { name: '照搬', count: '21,098', enabled: true },
            { name: '套路剧情', count: '19,876', enabled: true },
            { name: '拖沓', count: '18,765', enabled: true },
            { name: '场次混乱', count: '17,654', enabled: true },
            { name: '临时取消', count: '16,543', enabled: true },
            { name: '卫生脏乱', count: '15,432', enabled: true },
            { name: '安全隐患', count: '14,321', enabled: true },
            { name: '防护缺失', count: '13,210', enabled: true },
            { name: '排队过长', count: '12,109', enabled: true },
            { name: '效率低', count: '11,098', enabled: true },
            { name: '标识不清', count: '10,987', enabled: true },
            { name: '指引混乱', count: '9,876', enabled: true },
            { name: '服务态度差', count: '8,765', enabled: true },
            { name: '价格虚高', count: '7,654', enabled: true },
            { name: '虚假宣传', count: '6,543', enabled: true },
            { name: '抄袭', count: '5,432', enabled: true },
            { name: '模仿', count: '4,321', enabled: true },
            { name: '缺乏原创', count: '3,210', enabled: true },
            { name: '不值票价', count: '2,109', enabled: true },
            { name: '体验感差', count: '1,098', enabled: true },
            { name: '性价比低', count: '987', enabled: true },
            { name: '踩雷', count: '876', enabled: true },
            { name: '避坑', count: '765', enabled: true },
            { name: '不推荐', count: '654', enabled: true },
            { name: '后悔前往', count: '543', enabled: true },
            { name: '名不副实', count: '432', enabled: true },
            { name: '浪费时间', count: '321', enabled: true },
            { name: '劝退', count: '210', enabled: true },
            { name: '投诉无门', count: '109', enabled: true }
          ]
        },
        {
          id: 2,
          name: '篁岭景区舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-02 14:00:00',
          updateTime: '2026-06-07 16:20:00',
          keywords: [
            { name: '拖沓', count: '45,678', enabled: true },
            { name: '场次混乱', count: '34,567', enabled: true },
            { name: '临时取消', count: '23,456', enabled: true },
            { name: '卫生脏乱', count: '21,345', enabled: true },
            { name: '安全隐患', count: '19,234', enabled: true },
            { name: '防护缺失', count: '18,123', enabled: true },
            { name: '排队过长', count: '17,012', enabled: true },
            { name: '效率低', count: '15,901', enabled: true },
            { name: '标识不清', count: '14,890', enabled: true },
            { name: '指引混乱', count: '13,789', enabled: true }
          ]
        },
        {
          id: 3,
          name: '江湾景区舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-03 10:00:00',
          updateTime: '2026-06-08 09:15:00',
          keywords: []
        },
        {
          id: 4,
          name: '李坑景区舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-03 11:30:00',
          updateTime: '2026-06-08 08:45:00',
          keywords: []
        },
        {
          id: 5,
          name: '思溪延村舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-03 14:00:00',
          updateTime: '2026-06-08 07:30:00',
          keywords: []
        },
        {
          id: 7,
          name: '大山卧龙谷舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-04 10:00:00',
          updateTime: '2026-06-08 05:30:00',
          keywords: []
        },
        {
          id: 8,
          name: '灵岩洞景区舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-04 11:00:00',
          updateTime: '2026-06-08 05:00:00',
          keywords: []
        },
        {
          id: 9,
          name: '石城景区舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-04 13:00:00',
          updateTime: '2026-06-08 04:30:00',
          keywords: []
        },
        {
          id: 10,
          name: '长溪村舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-04 14:00:00',
          updateTime: '2026-06-08 04:00:00',
          keywords: []
        },
        {
          id: 11,
          name: '严台古村舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-04 15:00:00',
          updateTime: '2026-06-08 03:30:00',
          keywords: []
        },
        {
          id: 12,
          name: '段莘水库舆情监控方案',
          status: 'running',
          statusDisplay: '运行中',
          createTime: '2026-06-04 16:00:00',
          updateTime: '2026-06-08 03:00:00',
          keywords: []
        }
      ],
      planModalVisible: false,
      planFormModalVisible: false,
      editingPlan: {
        id: null,
        name: '',
        status: 'running'
      },
      negativeKeywordList: [
        '票价贵', '拥挤', '管理混乱', '周边堵车', '秩序混乱', '过度商业化', '同质化严重',
        '缺乏创新', '照搬', '套路剧情', '拖沓', '场次混乱', '临时取消', '卫生脏乱',
        '安全隐患', '防护缺失', '排队过长', '效率低', '标识不清', '指引混乱',
        '服务态度差', '价格虚高', '虚假宣传', '抄袭', '模仿', '缺乏原创',
        '不值票价', '体验感差', '性价比低', '踩雷', '避坑', '不推荐',
        '后悔前往', '名不副实', '浪费时间', '劝退', '投诉无门'
      ],
      negativeKeywordModalVisible: false,
      propagationModalVisible: false,
      propagationListData: [],
      keywordModalVisible: false,
      keywordEditModalVisible: false,
      editingKeywordIndex: -1,
      editingKeyword: {
        name: '',
        count: ''
      },
      batchImportModalVisible: false,
      batchImportText: '',
      sentimentList: [],
      supervisionWarningList: [
        { 
          id: 'WO-20240801-001',
          content: '游客投诉景区服务质量问题', 
          source: 'XXX平台',
          publishDate: '2026-06-05',
          type: '投诉',
          forwardCount: 56,
          likeCount: 96,
          commentCount: 58,
          originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx',
          originalContent: '游客反映在景区游玩期间，遇到了服务态度恶劣、设施维护不及时等问题，希望景区能够重视并改进服务质量。',
          isNegative: true,
          status: '待受理',
          responsibleParty: '景区服务组',
          createTime: '2026-06-05 09:30:00'
        },
        { 
          id: 'WO-20240802-002',
          content: '景区门票价格争议引发热议', 
          source: '社交媒体',
          publishDate: '2026-06-05',
          type: '舆情',
          forwardCount: 128,
          likeCount: 234,
          commentCount: 89,
          originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx',
          originalContent: '近期有网友在社交媒体上发布关于景区门票价格过高的讨论，引发广泛关注和争议。',
          isNegative: true,
          status: '处理中',
          responsibleParty: '票务管理组',
          createTime: '2026-06-05 14:20:00'
        },
        { 
          id: 'WO-20240803-003',
          content: '景区新增景点备受好评', 
          source: '新闻媒体',
          publishDate: '2026-06-05',
          type: '正面报道',
          forwardCount: 89,
          likeCount: 456,
          commentCount: 123,
          originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx',
          originalContent: '景区新增的自然风光景点受到游客一致好评，成为新的打卡热点。',
          isNegative: false,
          status: '已办结',
          responsibleParty: '市场推广组',
          createTime: '2026-06-05 10:15:00'
        },
        { id: 'WO-20240804-004', content: '节假日景区客流高峰应对措施', source: '官方公告', publishDate: '2026-06-05', type: '公告', forwardCount: 45, likeCount: 167, commentCount: 34, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '针对即将到来的节假日客流高峰，景区已制定详细的应对措施，确保游客安全有序游览。', isNegative: false, status: '已办结', responsibleParty: '运营管理组', createTime: '2026-06-05 08:00:00' },
        { id: 'WO-20240805-005', content: '景区餐饮价格问题引发关注', source: '消费者平台', publishDate: '2026-06-05', type: '投诉', forwardCount: 78, likeCount: 145, commentCount: 67, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '有游客反映景区内餐饮价格偏高，希望能够出台相关措施规范价格。', isNegative: true, status: '待受理', responsibleParty: '餐饮管理组', createTime: '2026-06-05 16:45:00' },
        { id: 'WO-20240806-006', content: '景区环境卫生状况改善', source: '旅游局通报', publishDate: '2026-06-05', type: '正面报道', forwardCount: 34, likeCount: 89, commentCount: 23, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '经过一段时间的整治，景区环境卫生状况得到明显改善，游客满意度提升。', isNegative: false, status: '已办结', responsibleParty: '环境维护组', createTime: '2026-06-05 11:30:00' },
        { id: 'WO-20240807-007', content: '景区交通拥堵问题亟待解决', source: '市民热线', publishDate: '2026-06-05', type: '投诉', forwardCount: 156, likeCount: 234, commentCount: 89, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '游客反映景区周边交通拥堵严重，建议增加停车位和优化交通疏导措施', isNegative: true, status: '处理中', responsibleParty: '交通管理组', createTime: '2026-06-05 13:20:00' },
        { id: 'WO-20240808-008', content: '景区推出新优惠政策', source: '官方微信', publishDate: '2026-06-05', type: '公告', forwardCount: 67, likeCount: 345, commentCount: 56, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '景区推出针对学生和老年人的优惠政策，受到社会各界好评。', isNegative: false, status: '已办结', responsibleParty: '市场推广组', createTime: '2026-06-05 09:00:00' },
        { id: 'WO-20240809-009', content: '游客走失事件引发安全关注', source: '新闻报道', publishDate: '2026-06-05', type: '负面', forwardCount: 234, likeCount: 567, commentCount: 178, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '近期发生一起游客走失事件，提醒景区加强安全管理和游客引导工作。', isNegative: true, status: '待受理', responsibleParty: '安全管理组', createTime: '2026-06-05 15:10:00' },
        { id: 'WO-20240810-010', content: '景区夜景灯光秀获赞', source: '短视频平台', publishDate: '2026-06-05', type: '正面报道', forwardCount: 456, likeCount: 890, commentCount: 345, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '景区推出的夜景灯光秀成为夜间旅游新亮点，吸引大量游客前来观赏。', isNegative: false, status: '已办结', responsibleParty: '活动策划组', createTime: '2026-06-05 20:00:00' },
        { id: 'WO-20240811-011', content: '景区停车场收费标准调整', source: '物价局公告', publishDate: '2026-06-05', type: '公告', forwardCount: 23, likeCount: 67, commentCount: 45, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '根据相关规定，景区停车场收费标准进行调整，新标准将于下月起执行。', isNegative: false, status: '已办结', responsibleParty: '财务管理组', createTime: '2026-06-05 10:30:00' },
        { content: '游客文明旅游意识提升', source: '文明办', publishDate: '2026-06-05', type: '正面报道', forwardCount: 45, likeCount: 123, commentCount: 23, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '通过宣传教育，游客文明旅游意识明显提升，景区环境更加整洁有序。' },
        { content: '景区临时闭园通知', source: '官方网站', publishDate: '2026-06-05', type: '公告', forwardCount: 78, likeCount: 45, commentCount: 89, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '因设备维护需要，景区将于本周六临时闭园一天，请游客合理安排行程。' },
        { content: '景区导游服务质量提升', source: '旅游协会', publishDate: '2026-06-05', type: '正面报道', forwardCount: 56, likeCount: 178, commentCount: 34, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '景区导游经过专业培训，服务质量和讲解水平得到显著提升。' },
        { content: '景区商业氛围过浓引发争议', source: '旅游论坛', publishDate: '2026-06-05', type: '舆情', forwardCount: 134, likeCount: 267, commentCount: 145, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '有游客反映景区内商业店铺过多，影响游览体验，建议适当控制商业规模。' },
        { content: '景区举办文化节活动', source: '文旅局', publishDate: '2026-06-05', type: '正面报道', forwardCount: 89, likeCount: 345, commentCount: 78, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '景区即将举办大型文化节活动，届时将有丰富多彩的文艺演出和特色展览' },
        { content: '景区厕所卫生问题被曝光', source: '自媒体', publishDate: '2026-06-05', type: '负面', forwardCount: 267, likeCount: 456, commentCount: 234, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '有自媒体曝光景区部分厕所卫生状况不佳，希望景区加强卫生管理。' },
        { content: '景区智能化服务升级', source: '科技公司', publishDate: '2026-06-05', type: '正面报道', forwardCount: 67, likeCount: 189, commentCount: 45, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '景区引入智能导览系统和人脸识别技术，提升游客体验和管理效率。' },
        { content: '景区周边住宿价格上涨', source: '预订平台', publishDate: '2026-06-05', type: '舆情', forwardCount: 145, likeCount: 278, commentCount: 134, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '节假日期间景区周边住宿价格大幅上涨，引发游客不满和媒体关注。' },
        { content: '景区志愿者服务获好评', source: '志愿者协会', publishDate: '2026-06-05', type: '正面报道', forwardCount: 56, likeCount: 134, commentCount: 23, originalUrl: 'https://xxxxxxxxxxxxxxxxxxxxxxxx', originalContent: '景区志愿者热情服务游客，成为景区一道亮丽的风景线。' }
      ],
      sentimentDetailModalVisible: false,
      currentSentimentDetail: {
        content: '',
        source: '',
        publishDate: '',
        type: '',
        forwardCount: 0,
        likeCount: 0,
        commentCount: 0,
        originalUrl: '',
        originalContent: ''
      },
      confirmModalVisible: false,
      confirmModalData: {
        id: '',
        content: '',
        responsibleParty: '',
        selectedParty: '',
        index: -1
      },
      responsibleParties: [
        '景区服务组',
        '票务管理组',
        '市场推广组',
        '运营管理组',
        '餐饮管理组',
        '环境维护组',
        '交通管理组',
        '安全管理组',
        '活动策划组',
        '财务管理组'
      ],
      tipModalVisible: false,
      tipModalMessage: '',
      exportModalVisible: false,
      exportForm: {
        startDate: '',
        endDate: '',
        type: '',
        status: '',
        responsibleParty: ''
      }
    }
  },
  mounted() {
    if (!this.$route.query.id) {
      const id = sessionStorage.getItem('scenicId')
      this.$router.push({ path: '/scenic_warning', query: { id: id, token: store.state.token } })
      this.$router.go(0)
      return
    }

    this.scenic_id = this.$route.query.id
    this.getToday()

    if (this.$route.query.date) {
      this.req_date = this.$route.query.date
      if (this.req_date) {
        const reDate = new Date(this.req_date)
        this.changeWeek = this.getWeek(reDate.getDay())
      }
    }

    if (this.$route.query.token) {
      this.$store.commit('setToken', this.$route.query.token)
    }

    this.isToday = !(this.req_date && this.req_date !== '' && this.req_date !== this.nowDay2)
    this.startClock()
    this.initPage()
    
    // 调用情感分析接口
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const today = `${year}-${month}-${day}`
    this.fetchSentimentOverview({ scenic_id: this.scenic_id, date: today })
    this.fetchSentimentArticles({ scenic_id: this.scenic_id, date: today })
    this.fetchSentimentKeywords({ scenic_id: this.scenic_id, date: today })
    this.fetchSentimentSources({ scenic_id: this.scenic_id, date: today })
    this.fetchSentimentWarnings({ scenic_id: this.scenic_id, date: today })
    
    this.$nextTick(() => {
      setTimeout(() => {
        this.renderWuyuanHeatMap()
      }, 300)
    })
  },
  beforeDestroy() {
    if (this.clockTimer) {
      clearInterval(this.clockTimer)
      this.clockTimer = null
    }
    if (this.boundaryLayer && this.boundaryLayer.setMap) {
      this.boundaryLayer.setMap(null)
      this.boundaryLayer = null
    }
    if (this.map && this.map.destroy) {
      this.map.destroy()
      this.map = null
    }
  },
  computed: {
    enabledKeywordList() {
      return this.currentPlanKeywords.filter(item => item.enabled !== false)
    },
    pendingWarningCount() {
      return this.supervisionWarningList.filter(item => item.isNegative && item.status === '待受理').length
    },
    currentPlan() {
      return this.planList.find(p => p.id === this.currentPlanId) || this.planList[0]
    },
    currentPlanKeywords() {
      const plan = this.planList.find(p => p.id === this.currentPlanId)
      return plan ? plan.keywords : []
    }
  },
  methods: {
    // 情感分析 - 概览数据
    async fetchSentimentOverview(query) {
      try {
        const res = await sentimentOverviewData(query)
        console.log('情感分析-概览数据:', res)
        if (res && res.data && res.data.data) {
          const data = res.data.data
          // 更新饼图数据
          this.sentimentPieData = data.pie.map(item => ({
            value: item.value,
            name: item.name,
            itemStyle: {
              color: item.type === 'positive' ? '#00D4AA' : item.type === 'neutral' ? '#5589F2' : '#E53F31'
            }
          }))
          // 更新柱状图数据
          this.sentimentBarData = data.sources.map(item => ({
            name: item.name,
            value: item.count
          }))
          // 更新负面关键词数据
          this.negativeKeywords = data.top_negative_keywords || []
          // 更新图表
          this.updateCharts()
        }
        return res
      } catch (error) {
        console.error('获取情感分析概览数据失败:', error)
      }
    },
    // 情感分析 - 文章分析
    async fetchSentimentArticles(query) {
      try {
        const res = await sentimentArticlesData(query)
        console.log('情感分析-文章数据:', res)
        if (res && res.data && res.data.results) {
          this.sentimentList = res.data.results.map(item => {
            const forwardCount = Math.floor(Math.random() * 20) + 10
            const likeCount = Math.floor(forwardCount * (Math.random() * 2 + 1))
            const commentCount = Math.floor(forwardCount * (Math.random() * 1.5 + 0.3))
            return {
              id: item.id,
              title: item.title,
              content: item.content,
              source: item.source,
              sentiment: item.sentiment,
              sentiment_display: item.sentiment_display,
              isHot: item.is_hot,
              publishTime: item.publish_time,
              url: item.url,
              matchKeywords: item.match_keywords,
              forwardCount,
              likeCount,
              commentCount
            }
          })
        }
        return res
      } catch (error) {
        console.error('获取情感分析文章数据失败:', error)
      }
    },
    // 情感分析 - 关键词分析
    async fetchSentimentKeywords(query) {
      try {
        console.log('关键词管理使用静态数据')
        return { data: { data: this.keywordList } }
      } catch (error) {
        console.error('获取关键词数据失败:', error)
      }
    },
    // 情感分析 - 来源分析
    async fetchSentimentSources(query) {
      try {
        const res = await sentimentSourcesData(query)
        console.log('情感分析-来源数据:', res)
        return res
      } catch (error) {
        console.error('获取情感分析来源数据失败:', error)
      }
    },
    // 情感分析 - 警告分析
    async fetchSentimentWarnings(query) {
      try {
        const res = await sentimentWarningsData(query)
        console.log('情感分析-警告数据:', res)
        if (res && res.data && res.data.results) {
          this.supervisionWarningList = res.data.results.map(item => {
            const forwardCount = Math.floor(Math.random() * 20) + 10
            const likeCount = Math.floor(forwardCount * (Math.random() * 2 + 1))
            const commentCount = Math.floor(forwardCount * (Math.random() * 1.5 + 0.3))
            const isNegative = item.level === 'high' || item.level === 'medium'
            const typeMap = { high: '投诉', medium: '舆情', low: '建议' }
            const statusMap = { pending: '待受理', processing: '处理中', completed: '已办结' }
            const responsiblePartyMap = {
              high: '景区服务组',
              medium: '市场推广组',
              low: '运营管理组'
            }
            return {
              id: 'WO-' + item.id,
              content: item.title,
              source: item.source,
              publishDate: item.publish_time ? item.publish_time.split(' ')[0] : new Date().toISOString().split('T')[0],
              type: typeMap[item.level] || '舆情',
              forwardCount: forwardCount,
              likeCount: likeCount,
              commentCount: commentCount,
              originalUrl: '',
              originalContent: item.content || '',
              isNegative: isNegative,
              status: statusMap[item.status] || '待受理',
              responsibleParty: responsiblePartyMap[item.level] || '景区服务组',
              createTime: item.created_at || new Date().toLocaleString('zh-CN'),
              level: item.level,
              level_display: item.level_display,
              keyword: item.keyword,
              handler_name: item.handler_name,
              handle_result: item.handle_result,
              handle_time: item.handle_time,
              heat: item.heat
            }
          })
        }
        return res
      } catch (error) {
        console.error('获取情感分析警告数据失败:', error)
      }
    },
    // 情感分析 - 警告处理
    async handleSentimentWarning(id, data) {
      try {
        const res = await sentimentWarningsHandleData({ id, data })
        console.log('情感分析-警告处理:', res)
        return res
      } catch (error) {
        console.error('处理情感分析警告失败:', error)
      }
    },
    openPlanModal() {
      this.planModalVisible = true
      const scrollWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = scrollWidth + 'px'
    },
    closePlanModal() {
      this.planModalVisible = false
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    },
    openPlanFormModal(plan = null) {
      if (plan) {
        this.editingPlan = {
          id: plan.id,
          name: plan.name,
          status: plan.status
        }
      } else {
        this.editingPlan = {
          id: null,
          name: '',
          status: 'running'
        }
      }
      this.planFormModalVisible = true
      const scrollWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = scrollWidth + 'px'
    },
    closePlanFormModal() {
      this.planFormModalVisible = false
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    },
    deletePlan(id) {
      if (confirm('确定要删除该方案吗？')) {
        const index = this.planList.findIndex(p => p.id === id)
        if (index !== -1) {
          this.planList.splice(index, 1)
        }
      }
    },
    savePlan() {
      if (!this.editingPlan.name.trim()) {
        alert('请输入方案名称')
        return
      }
      if (this.editingPlan.id) {
        const index = this.planList.findIndex(p => p.id === this.editingPlan.id)
        if (index !== -1) {
          this.planList[index] = {
            ...this.planList[index],
            name: this.editingPlan.name,
            status: this.editingPlan.status,
            statusDisplay: this.editingPlan.status === 'running' ? '运行中' : '已停止',
            updateTime: new Date().toLocaleString('zh-CN')
          }
        }
      } else {
        this.planList.push({
          id: Date.now(),
          name: this.editingPlan.name,
          status: this.editingPlan.status,
          statusDisplay: this.editingPlan.status === 'running' ? '运行中' : '已停止',
          createTime: new Date().toLocaleString('zh-CN'),
          updateTime: new Date().toLocaleString('zh-CN')
        })
      }
      this.closePlanFormModal()
    },
    openKeywordModal(planId) {
      this.currentPlanId = planId || 1
      this.keywordModalVisible = true
      const scrollWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = scrollWidth + 'px'
    },
    closeKeywordModal() {
      this.keywordModalVisible = false
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    },
    openNegativeKeywordModal() {
      this.negativeKeywordModalVisible = true
      const scrollWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = scrollWidth + 'px'
    },
    closeNegativeKeywordModal() {
      this.negativeKeywordModalVisible = false
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    },
    addKeyword() {
      this.editingKeywordIndex = -1
      this.editingKeyword = { name: '', count: '0' }
      this.keywordEditModalVisible = true
      const scrollWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = scrollWidth + 'px'
    },
    editKeyword(index) {
      this.editingKeywordIndex = index
      this.editingKeyword = { ...this.currentPlanKeywords[index] }
      this.keywordEditModalVisible = true
      const scrollWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = scrollWidth + 'px'
    },
    deleteKeyword(index) {
      this.currentPlanKeywords.splice(index, 1)
    },
    toggleKeywordEnabled(index) {
      this.currentPlanKeywords[index].enabled = !this.currentPlanKeywords[index].enabled
    },
    closeKeywordEditModal() {
      this.keywordEditModalVisible = false
      this.editingKeywordIndex = -1
      this.editingKeyword = { name: '', count: '' }
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    },
    saveKeyword() {
      if (!this.editingKeyword.name.trim()) {
        // alert('请输入关键词')
        return
      }
      if (this.editingKeywordIndex === -1) {
        this.currentPlanKeywords.push({ ...this.editingKeyword })
      } else {
        this.currentPlanKeywords[this.editingKeywordIndex] = { ...this.editingKeyword }
      }
      this.closeKeywordEditModal()
    },
    openBatchImportModal() {
      this.batchImportModalVisible = true
      this.batchImportText = ''
      const scrollWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = scrollWidth + 'px'
    },
    closeBatchImportModal() {
      this.batchImportModalVisible = false
      this.batchImportText = ''
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    },
    confirmBatchImport() {
      if (!this.batchImportText.trim()) {
        return
      }
      const existingKeywords = this.keywordList.map(item => item.name)
      const duplicateKeywords = []
      const newKeywords = []
      
      // 先按换行分割，再按逗号分割，支持多行和单行逗号分隔
      const lines = this.batchImportText.trim().split('\n')
      const allKeywords = []
      
      lines.forEach(line => {
        const trimmedLine = line.trim()
        if (trimmedLine) {
          // 每行按逗号分割
          const parts = trimmedLine.split(',')
          parts.forEach(part => {
            const keyword = part.trim()
            if (keyword && !allKeywords.includes(keyword)) {
              allKeywords.push(keyword)
            }
          })
        }
      })
      
      allKeywords.forEach(keyword => {
        if (existingKeywords.includes(keyword)) {
          duplicateKeywords.push(keyword)
        } else {
          newKeywords.push(keyword)
          this.keywordList.push({ name: keyword, count: '0' })
        }
      })
      
      if (duplicateKeywords.length > 0) {
        this.showTipModal('以下关键词已存在，无法导入：' + duplicateKeywords.join('、'))
      }
      
      this.closeBatchImportModal()
    },
    showTipModal(message) {
      this.tipModalMessage = message
      this.tipModalVisible = true
    },
    closeTipModal() {
      this.tipModalVisible = false
    },
    openExportModal() {
      this.exportModalVisible = true
    },
    closeExportModal() {
      this.exportModalVisible = false
    },
    exportWorkOrder() {
      let filteredList = this.supervisionWarningList.filter(item => {
        if (item.id) {
          if (this.exportForm.startDate && item.publishDate < this.exportForm.startDate) {
            return false
          }
          if (this.exportForm.endDate && item.publishDate > this.exportForm.endDate) {
            return false
          }
          if (this.exportForm.type && item.type !== this.exportForm.type) {
            return false
          }
          if (this.exportForm.status && item.status !== this.exportForm.status) {
            return false
          }
          if (this.exportForm.responsibleParty && item.responsibleParty !== this.exportForm.responsibleParty) {
            return false
          }
          return true
        }
        return false
      })

      if (filteredList.length === 0) {
        this.showTipModal('没有符合条件的数据可导出')
        return
      }
      
      let csvContent = '工单编号,舆情内容,来源,发布日期,类型,转发数,点赞数,评论数,责任主体,处理状态,创建时间\n'
      
      filteredList.forEach(item => {
        const content = `"${item.content.replace(/"/g, '""')}"`
        csvContent += `${item.id},${content},${item.source},${item.publishDate},${item.type},${item.forwardCount},${item.likeCount},${item.commentCount},${item.responsibleParty || '-'},${item.status || '-'},${item.createTime || '-'}\n`
      })

      const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', `问题台账_${new Date().toISOString().split('T')[0]}.csv`)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      this.closeExportModal()
    },
    generateWorkOrder(index) {
      const item = this.supervisionWarningList[index]
      this.confirmModalData = {
        id: item.id,
        content: item.content,
        responsibleParty: item.responsibleParty,
        selectedParty: item.responsibleParty,
        index: index
      }
      this.confirmModalVisible = true
    },
    closeConfirmModal() {
      this.confirmModalVisible = false
    },
    confirmGenerateWorkOrder() {
      const index = this.confirmModalData.index
      const item = this.supervisionWarningList[index]
      item.status = '处理中'
      item.responsibleParty = this.confirmModalData.selectedParty
      this.confirmModalVisible = false
    },
    openSentimentDetail(item) {
      this.currentSentimentDetail = { ...item }
      this.sentimentDetailModalVisible = true
    },
    closeSentimentDetailModal() {
      this.sentimentDetailModalVisible = false
      this.currentSentimentDetail = {
        content: '',
        source: '',
        publishDate: '',
        type: '',
        forwardCount: 0,
        likeCount: 0,
        commentCount: 0,
        originalUrl: '',
        originalContent: ''
      }
    },
    // 打开传播链路弹窗
    openPropagationModal(item) {
      this.propagationModalVisible = true
      this.generatePropagationData(item)
      this.$nextTick(() => {
        this.initPropagationChart()
      })
    },
    // 关闭传播链路弹窗
    closePropagationModal() {
      this.propagationModalVisible = false
    },
    // 生成传播链路数据
    generatePropagationData(item) {
      const types = [
        { type: 'repost', display: '转载' },
        { type: 'comment', display: '评论' },
        { type: 'quote', display: '引用' }
      ]
      const sources = ['微信公众号', '微博', '抖音', '小红书', '今日头条', '知乎', 'B 站']
      
      const propagationList = []
      
      // 生成 3-6 条传播记录（转载、评论、引用）
      const propagationCount = Math.floor(Math.random() * 4) + 3
      const now = new Date()
      
      // 生成递减的时间（越往后传播时间越早）
      for (let i = 0; i < propagationCount; i++) {
        const randomType = types[Math.floor(Math.random() * types.length)]
        const randomSource = sources[Math.floor(Math.random() * sources.length)]
        
        // 生成递减的时间（最新的在最上面）
        const pastTime = new Date(now.getTime() - i * 3600000)
        const timeStr = `${pastTime.getFullYear()}年${pastTime.getMonth() + 1}月${pastTime.getDate()}日 ${String(pastTime.getHours()).padStart(2, '0')}:${String(pastTime.getMinutes()).padStart(2, '0')}`
        
        propagationList.push({
          type: randomType.type,
          typeDisplay: randomType.display,
          source: randomSource,
          publishTime: timeStr
        })
      }
      
      // 添加原文（最下面，时间最早）
      const originalTime = new Date(now.getTime() - (propagationCount + 1) * 3600000)
      const originalTimeStr = `${originalTime.getFullYear()}年${originalTime.getMonth() + 1}月${originalTime.getDate()}日 ${String(originalTime.getHours()).padStart(2, '0')}:${String(originalTime.getMinutes()).padStart(2, '0')}`
      
      propagationList.push({
        type: 'original',
        typeDisplay: '原文',
        source: item.source || '未知来源',
        publishTime: originalTimeStr
      })
      
      this.propagationListData = propagationList
    },
    initPage() {
      this.getSettingById().then(() => {
        this.$nextTick(() => {
          this.initCharts()
        })
      })
    },
    initCharts() {
      this.initPieChart()
      this.initBarChart()
    },
    initPieChart() {
      const chartDom = document.getElementById('sentimentPieChart')
      if (!chartDom) return
      this.pieChart = this.echarts.init(chartDom)
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: 'center',
          data: ['正面', '中性', '负面'],
          textStyle: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 12
          }
        },
        series: [
          {
            name: '舆情统计',
            type: 'pie',
            radius: ['35%', '55%'],
            center: ['35%', '50%'],
            data: this.sentimentPieData,
            label: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12
            },
            emphasis: {
              label: {
                show: true,
                formatter: '{b} : {c} ({d}%)'
              }
            }
          }
        ]
      }
      this.pieChart.setOption(option)
    },
    updateCharts() {
      if (this.pieChart) {
        this.pieChart.setOption({
          series: [{
            data: this.sentimentPieData
          }]
        })
      }
      if (this.barChart) {
        this.barChart.setOption({
          xAxis: [{
            data: this.sentimentBarData.map(item => item.name)
          }],
          series: [{
            data: this.sentimentBarData.map(item => item.value)
          }]
        })
      }
    },
    initBarChart() {
      const chartDom = document.getElementById('sentimentBarChart')
      if (!chartDom) return
      this.barChart = this.echarts.init(chartDom)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          top: '10%',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.sentimentBarData.map(item => item.name),
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12,
              interval: 0,
              rotate: 30
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)'
              }
            }
          }
        ],
        series: [
          {
            name: '舆情数量',
            type: 'bar',
            data: this.sentimentBarData.map(item => item.value),
            itemStyle: {
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#5589F2' },
                { offset: 1, color: '#3F66FF' }
              ])
            },
            barWidth: '40%'
          }
        ]
      }
      this.barChart.setOption(option)
    },
    getToday() {
      const today = new Date()
      const year = today.getFullYear()
      let month = today.getMonth() + 1
      let date = today.getDate()
      let day = today.getDay()
      let hour = today.getHours()
      let minute = today.getMinutes()
      let second = today.getSeconds()

      month = this.doHandleMonth(month)
      date = this.doHandleDate(date)
      hour = this.doHandleHour(hour)
      minute = this.doHandleMinute(minute)
      second = this.doHandleSecond(second)

      this.nowDay = year + '-' + month + '-' + date
      this.nowDay2 = year + '-' + month + '-' + date
      this.nowTime = hour + ':' + minute + ':' + second
      this.week = this.getWeek(day)
    },
    doHandleMonth(month) {
      if (month < 10) {
        return '0' + month
      }
      return month
    },
    doHandleDate(date) {
      if (date < 10) {
        return '0' + date
      }
      return date
    },
    doHandleHour(hour) {
      if (hour < 10) {
        return '0' + hour
      }
      return hour
    },
    doHandleMinute(minute) {
      if (minute < 10) {
        return '0' + minute
      }
      return minute
    },
    doHandleSecond(second) {
      if (second < 10) {
        return '0' + second
      }
      return second
    },
    getWeek(day) {
      const weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      return weekArr[day]
    },
    startClock() {
      this.clockTimer = setInterval(() => {
        const today = new Date()
        let hour = today.getHours()
        let minute = today.getMinutes()
        let second = today.getSeconds()

        hour = this.doHandleHour(hour)
        minute = this.doHandleMinute(minute)
        second = this.doHandleSecond(second)

        this.nowTime = hour + ':' + minute + ':' + second
      }, 1000)
    },
    getSettingById() {
      return getSettingByIdApi({
        scenic_id: this.scenic_id
      }).then(res => {
        if (res.data && res.data.data) {
          this.setting = Object.assign({}, this.setting, res.data.data)
        }
      }).catch(() => {
        return Promise.resolve()
      })
    },
    fetchBoundaryData() {
      const fetchWithFallback = (urls, index = 0) => {
        if (index >= urls.length) {
          return Promise.reject(new Error('All boundary data sources failed'))
        }
        return fetch(urls[index])
          .then(response => {
            if (!response.ok) {
              throw new Error(`Failed to fetch ${urls[index]}`)
            }
            return response.json()
          })
          .catch(() => fetchWithFallback(urls, index + 1))
      }
      return fetchWithFallback(WUYUAN_BOUNDARY_URLS)
    },
    calculateBoundaryBounds() {
      if (!this.boundaryGeometries || this.boundaryGeometries.length === 0) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      let minLat = Infinity, maxLat = -Infinity
      let minLng = Infinity, maxLng = -Infinity

      try {
        this.boundaryGeometries.forEach(geo => {
          if (!geo || !geo.coordinates || geo.coordinates.length === 0) {
            return
          }
          const coordinates = geo.coordinates[0]
          if (!coordinates || !Array.isArray(coordinates)) {
            return
          }
          coordinates.forEach(point => {
            if (!point || point.length < 2) {
              return
            }
            const lng = point[0]
            const lat = point[1]
            if (isNaN(lng) || isNaN(lat)) {
              return
            }
            minLng = Math.min(minLng, lng)
            maxLng = Math.max(maxLng, lng)
            minLat = Math.min(minLat, lat)
            maxLat = Math.max(maxLat, lat)
          })
        })
      } catch (error) {
        console.error('Error calculating boundary bounds:', error)
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      if (minLat === Infinity || maxLat === -Infinity || minLng === Infinity || maxLng === -Infinity) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      const paddingX = (maxLng - minLng) * WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO
      const paddingY = (maxLat - minLat) * WUYUAN_VIEW_VERTICAL_PADDING_RATIO

      if (paddingX <= 0 || paddingY <= 0) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      this.boundaryBounds = {
        sw: { lat: minLat - paddingY, lng: minLng - paddingX },
        ne: { lat: maxLat + paddingY, lng: maxLng + paddingX }
      }

      const centerLat = (minLat + maxLat) / 2
      const centerLng = (minLng + maxLng) / 2
      const viewportWidth = (maxLng - minLng) * (1 + WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO * 2)
      const viewportHeight = (maxLat - minLat) * (1 + WUYUAN_VIEW_VERTICAL_PADDING_RATIO * 2)

      this.viewportBounds = {
        sw: { lat: centerLat - viewportHeight / 2, lng: centerLng - viewportWidth / 2 },
        ne: { lat: centerLat + viewportHeight / 2, lng: centerLng + viewportWidth / 2 }
      }
      return this.boundaryBounds
    },
    renderBoundaryLayer() {
      if (!this.map || !this.boundaryGeometries.length) {
        return
      }

      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
      }

      const boundaryStyle = new TMap.PolygonStyle({
        color: 'rgba(24, 50, 112, 0.10)',
        showBorder: true,
        borderColor: 'rgba(120, 238, 255, 0.95)',
        borderWidth: 3
      })

      this.boundaryLayer = new TMap.MultiPolygon({
        map: this.map,
        zIndex: 2,
        styles: {
          boundary: boundaryStyle
        },
        geometries: this.boundaryGeometries
      })
    },
    renderWuyuanHeatMap(retryCount = 0) {
      const maxRetries = 20
      const mapContainer = document.getElementById(this.mapId)
      
      if (!mapContainer) {
        console.log('Map container not found with id:', this.mapId)
        if (retryCount < maxRetries) {
          requestAnimationFrame(() => {
            this.renderWuyuanHeatMap(retryCount + 1)
          })
        }
        return
      }

      const rect = mapContainer.getBoundingClientRect()
      console.log('Map container rect (attempt', retryCount + 1, '):', rect)
      
      if (rect.width <= 0 || rect.height <= 0) {
        console.log('Map container size is invalid (width:', rect.width, ', height:', rect.height, '), retrying...')
        
        const parent = mapContainer.parentElement
        if (parent) {
          const parentRect = parent.getBoundingClientRect()
          console.log('Parent container rect:', parentRect)
          
          const grandParent = parent.parentElement
          if (grandParent) {
            const grandParentRect = grandParent.getBoundingClientRect()
            console.log('Grand parent container rect:', grandParentRect)
          }
        }
        
        if (retryCount < maxRetries) {
          setTimeout(() => {
            this.renderWuyuanHeatMap(retryCount + 1)
          }, 100 * (retryCount + 1))
        } else {
          console.error('Failed to initialize map: container size remains invalid after', maxRetries, 'retries')
        }
        return
      }

      console.log('Initializing map with valid container size:', rect.width, 'x', rect.height)

      const warningMapZoom = Math.max(Number(this.setting.map_show || 0), 11.2)
      const maxZoom = Math.max(warningMapZoom + 2.3, 14)
      const center = new TMap.LatLng(
        WUYUAN_CENTER.lat + Number(this.setting.lat_offset || 0),
        WUYUAN_CENTER.lng + Number(this.setting.lng_offset || 0)
      )

      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
        this.boundaryLayer = null
      }
      if (this.map && this.map.destroy) {
        this.map.destroy()
        this.map = null
      }

      const mapOptions = {
        zoom: warningMapZoom,
        minZoom: warningMapZoom,
        maxZoom: maxZoom,
        pitch: 12,
        center: center,
        mapStyleId: 'style3',
        showControl: false,
        baseMap: {
          type: 'vector',
          features: ['base', 'building3d', 'point']
        }
      }

      try {
        this.map = new TMap.Map(this.mapId, mapOptions)
        console.log('Map initialized successfully')
        
        this.fetchBoundaryData().then(geoJson => {
          if (geoJson && geoJson.features && geoJson.features.length > 0) {
            this.boundaryGeometries = geoJson.features.map(feature => ({
              id: feature.properties.name,
              coordinates: feature.geometry.coordinates,
              styleId: 'boundary'
            }))
            this.calculateBoundaryBounds()
            this.renderBoundaryLayer()
          }
        }).catch(() => {
          console.log('Failed to load boundary data')
        })
      } catch (error) {
        console.error('Failed to initialize map:', error)
      }
    },
    changeTheDate(day) {
      if (day === 0) {
        const query = {
          id: this.scenic_id,
          token: store.state.token
        }
        this.$router.push({ path: '/scenic_warning', query: query })
        this.$router.go(0)
        return
      }

      const today = this.req_date ? new Date(this.req_date) : new Date()
      const targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
      today.setTime(targetdayMilliseconds)
      const tYear = today.getFullYear()
      let tMonth = today.getMonth()
      let tDate = today.getDate()
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleDate(tDate)
      const changeDate = tYear + '-' + tMonth + '-' + tDate
      const query = {
        id: this.scenic_id,
        date: changeDate,
        token: store.state.token
      }
      this.$router.push({ path: '/scenic_warning', query: query })
      this.$router.go(0)
    }
  }
}
</script>

<style scoped>
.page-container {
  width: 100vw;
  height: calc(100vh - 54px);
  font-family: PingFang SC;
  user-select: none;
}

.data-box {
  background-color: rgba(3, 10, 69, 0.92);
  box-shadow: -1px -1px 10px 2px rgba(78, 240, 228, 0.1);
  background-image: url(../../static/img/border-top.png), url(../../static/img/border-bottom.png);
  background-repeat: no-repeat, no-repeat;
  background-position: -0.3% -0.3%, 100.3% 100.3%;
  border: 1px solid rgba(80, 220, 255, 0.28);
}

.head {
  position: relative;
  height: 80px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
}

.head-title {
  display: inline-block;
  font-size: 16px;
  vertical-align: middle;
}

.head-logo {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  transform: translate(0, -2px);
}

.head-type {
  width: 520px;
  max-width: 100%;
  height: 54px;
  display: flex;
  justify-content: space-around;
  vertical-align: middle;
}

.type-item {
  position: relative;
  height: 100%;
  display: inline-block;
  color: #575785;
  cursor: pointer;
}

.type-item2 {
  color: #fff;
}

.type-on {
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #023AFF;
  border-radius: 1px;
}

.date-weather {
  display: inline-block;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #fff;
}

.warning-main {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 500px;
  background: rgba(6, 14, 96, 0.6);
  overflow: hidden;
}

.migrateMap {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  min-width: 500px;
  min-height: 500px;
  background-color: #0a1628;
  z-index: 0;
}

.warning-left,
.warning-right {
  position: relative;
  z-index: 2;
  width: 420px;
  height: calc(100% - 32px);
}

.warning-left {
  float: left;
  margin: 16px 16px 0 16px;
  display: flex;
  flex-direction: column;
}

.warning-right {
  float: right;
  margin: 16px 16px 0 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.warning-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 20px 18px 16px;
  box-sizing: border-box;
  overflow: hidden;
  flex: 1;
  position: relative;
}

.panel-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-badge {
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #ff4d4f;
  border-radius: 10px;
  font-size: 12px;
  color: #fff;
  font-weight: 600;
  padding: 0 6px;
}

.warning-panel-large {
  height: calc(100% - 250px);
  min-height: 640px;
}

.warning-panel-small {
  margin-top: 14px;
  height: 236px;
}

.sentiment-panel {
  flex: 1;
  min-height: 0;
  margin-bottom: 14px;
}

.sentiment-panel:last-child {
  margin-bottom: 0;
}

.sentiment-chart {
  width: 100%;
  height: calc(100% - 30px);
  min-height: 120px;
}

.sentiment-keywords {
  margin-top: 12px;
}

.sentiment-keywords-title {
  font-size: 12px;
  color: #8cefff;
  margin-bottom: 10px;
  font-weight: 600;
}

.sentiment-keywords-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.sentiment-keyword-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: rgba(45, 72, 180, 0.35);
  border-radius: 4px;
}

.keyword-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.86);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
}

.keyword-count {
  font-size: 12px;
  color: #fff;
  font-weight: 600;
}

.keyword-panel-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.keyword-edit-btn {
  background: linear-gradient(135deg, #6fb8ff 0%, #00d4aa 100%);
  border: none;
  color: #141439;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 16px;
  border-radius: 12px;
  cursor: pointer;
}

.keyword-table-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-top: 12px;
  padding-right: 4px;
}

.keyword-table-container::-webkit-scrollbar {
  width: 4px;
}

.keyword-table-container::-webkit-scrollbar-track {
  background: transparent;
}

.keyword-table-container::-webkit-scrollbar-thumb {
  background: rgba(85, 137, 242, 0.5);
  border-radius: 2px;
}

.keyword-table {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.keyword-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 10px;
  background: rgba(45, 72, 180, 0.35);
  border-radius: 4px;
  position: relative;
  cursor: default;
}

.keyword-row.clickable {
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.keyword-row.clickable:hover {
  background: rgba(255, 100, 100, 0.2);
  border-color: rgba(255, 100, 100, 0.4);
}

.plan-status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 4px;
  background: #E53F31;
  transition: all 0.3s;
}

.plan-status-indicator.status-running {
  background: #00D4AA;
  box-shadow: 0 0 8px rgba(0, 212, 170, 0.5);
}

.keyword-tag {
  font-size: 12px;
  color: #8cefff;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}

.keyword-value {
  font-size: 14px;
  color: #fff;
  font-weight: 600;
}

.keyword-switch {
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;
}

.switch-track {
  display: inline-block;
  width: 28px;
  height: 16px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  position: relative;
  transition: background 0.3s;
  cursor: pointer;
}

.switch-track.switch-on {
  background: #4cd9ff;
}

.switch-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  transition: left 0.3s;
}

.switch-thumb.switch-thumb-on {
  left: 14px;
}



.warning-panel-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 18px;
}

.warning-right .warning-panel-title {
  margin-bottom: 12px;
  flex-shrink: 0;
}

.right-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.right-tab-item {
  padding: 8px 16px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.right-tab-item:hover {
  border-color: #4cd9ff;
  background: rgba(76, 217, 255, 0.1);
}

.right-tab-item.active {
  background: rgba(76, 217, 255, 0.2);
  border-color: #4cd9ff;
  color: #4cd9ff;
  font-weight: 600;
}

.right-tab-item {
  position: relative;
}

.tab-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 11px;
  color: #fff;
  background: #E53F31;
  border-radius: 9px;
  padding: 0 5px;
}

.sentiment-list {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.sentiment-item {
  padding: 12px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 6px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.sentiment-item:hover {
  background: rgba(76, 217, 255, 0.1);
  border-color: rgba(76, 217, 255, 0.3);
}

.sentiment-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.sentiment-title {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  margin-right: 12px;
}

.sentiment-source {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  padding: 2px 8px;
  background: rgba(76, 165, 255, 0.2);
  border-radius: 3px;
  flex-shrink: 0;
}

.sentiment-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.sentiment-stats {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
}

.propagation-link {
  color: #4cd9ff;
  cursor: pointer;
  text-decoration: underline;
}

.propagation-link:hover {
  color: #8cefff;
}

.sentiment-tag {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 3px;
}

.sentiment-positive {
  color: #00D4AA;
  background: rgba(0, 212, 170, 0.2);
}

.sentiment-neutral {
  color: #5589F2;
  background: rgba(85, 137, 242, 0.2);
}

.sentiment-negative {
  color: #E53F31;
  background: rgba(229, 63, 49, 0.2);
}

.sentiment-time {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

.no-data {
  text-align: center;
  padding: 40px 20px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

.warning-panel-full {
  height: calc(100% - 20px);
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.supervision-warning-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.supervision-warning-list::-webkit-scrollbar {
  width: 4px;
}

.supervision-warning-list::-webkit-scrollbar-track {
  background: transparent;
}

.supervision-warning-list::-webkit-scrollbar-thumb {
  background: rgba(85, 137, 242, 0.5);
  border-radius: 2px;
}

.supervision-warning-item {
  padding: 12px;
  margin-bottom: 10px;
  background: rgba(45, 72, 180, 0.35);
  border-radius: 6px;
  border-left: 3px solid #5589F2;
}

.supervision-warning-item.negative-warning {
  border-left: 3px solid #E53F31;
  background: rgba(229, 63, 49, 0.15);
}

.supervision-warning-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.warning-id {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

.warning-status {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 600;
}

.status-待处理{
  background: rgba(255, 165, 0, 0.2);
  color: #FFA500;
}

.status-处理中{
  background: rgba(85, 137, 242, 0.2);
  color: #5589F2;
}

.status-已处理{
  background: rgba(0, 212, 170, 0.2);
  color: #00D4AA;
}

.supervision-warning-content {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin-bottom: 6px;
}

.supervision-warning-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.warning-type {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  padding: 2px 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.warning-type.negative-type {
  background: rgba(229, 63, 49, 0.2);
  color: #E53F31;
}

.warning-party {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

.warning-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.generate-workorder-btn {
  padding: 6px 12px;
  background: linear-gradient(135deg, #E53F31 0%, #C0392B 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.generate-workorder-btn:hover {
  background: linear-gradient(135deg, #F05F4F 0%, #D0493B 100%);
}

.export-button-container {
  margin-top: 16px;
  flex-shrink: 0;
}

.export-button {
  width: 100%;
  padding: 10px;
  background: linear-gradient(135deg, #5589F2 0%, #3F66FF 100%);
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.export-button:hover {
  background: linear-gradient(135deg, #6699FF 0%, #5575FF 100%);
}

/* 监控订阅方案弹窗样式 */
.plan-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
}
.plan-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}
.plan-modal-dialog {
  position: relative;
  width: 90%;
  max-width: 900px;
  margin: 80px auto;
  background: linear-gradient(180deg, rgba(12, 20, 60, 0.98) 0%, rgba(5, 10, 40, 0.98) 100%);
  border-radius: 12px;
  border: 1px solid rgba(85, 137, 242, 0.3);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}
.plan-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(85, 137, 242, 0.2);
}
.plan-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}
.plan-modal-close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  font-size: 28px;
  line-height: 1;
  border-radius: 6px;
  transition: all 0.3s;
}
.plan-modal-close:hover {
  color: #fff;
  background: rgba(229, 63, 49, 0.2);
}
.plan-modal-body {
  padding: 20px;
}
.plan-modal-toolbar {
  margin-bottom: 16px;
}
.plan-add-btn {
  padding: 8px 20px;
  background: linear-gradient(135deg, #5589F2 0%, #446AE8 100%);
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}
.plan-add-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(85, 137, 242, 0.4);
}
.plan-table-container {
  border: 1px solid rgba(85, 137, 242, 0.2);
  border-radius: 8px;
  overflow: hidden;
}
.plan-table-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1.5fr 1.5fr;
  gap: 0;
  background: rgba(85, 137, 242, 0.1);
  padding: 12px 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}
.plan-table-body {
  height: 450px;
  overflow-y: auto;
}
.plan-table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1.5fr 1.5fr;
  gap: 0;
  padding: 14px 16px;
  border-top: 1px solid rgba(85, 137, 242, 0.1);
  border-bottom: 1px solid rgba(85, 137, 242, 0.1);
  font-size: 14px;
  color: #fff;
  transition: background 0.3s;
  align-items: center;
}
.plan-table-row:hover {
  background: rgba(85, 137, 242, 0.08);
}
.plan-table-name {
  color: #fff;
  font-weight: 500;
}
.plan-table-status {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}
.plan-table-status.status-running {
  color: #00D4AA;
}
.plan-table-status:not(.status-running) {
  color: #E53F31;
}
.plan-table-time {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}
.plan-table-actions {
  display: flex;
  gap: 12px;
}
.plan-table-actions a {
  color: #5589F2;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s;
}
.plan-table-actions a:hover {
  color: #6699FF;
}
.plan-modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
  border-top: 1px solid rgba(85, 137, 242, 0.2);
}
.plan-modal-cancel-btn {
  padding: 10px 28px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}
.plan-modal-cancel-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

/* 监控订阅方案表单弹窗样式 */
.plan-form-modal {
  position: fixed;
  inset: 0;
  z-index: 1001;
}
.plan-form-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}
.plan-form-modal-dialog {
  position: relative;
  width: 90%;
  max-width: 500px;
  margin: 150px auto;
  background: linear-gradient(180deg, rgba(12, 20, 60, 0.98) 0%, rgba(5, 10, 40, 0.98) 100%);
  border-radius: 12px;
  border: 1px solid rgba(85, 137, 242, 0.3);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}
.plan-form-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(85, 137, 242, 0.2);
}
.plan-form-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}
.plan-form-modal-close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  font-size: 28px;
  line-height: 1;
  border-radius: 6px;
  transition: all 0.3s;
}
.plan-form-modal-close:hover {
  color: #fff;
  background: rgba(229, 63, 49, 0.2);
}
.plan-form-modal-body {
  padding: 20px;
}
.plan-form-item {
  margin-bottom: 16px;
}
.plan-form-item label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}
.plan-form-input {
  width: 100%;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(85, 137, 242, 0.3);
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}
.plan-form-input:focus {
  outline: none;
  border-color: #5589F2;
}
.plan-form-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}
.plan-form-select {
  width: 100%;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(85, 137, 242, 0.3);
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s;
  cursor: pointer;
}
.plan-form-select:focus {
  outline: none;
  border-color: #5589F2;
}
.plan-form-select option {
  background: #0c143c;
  color: #fff;
}
.plan-form-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid rgba(85, 137, 242, 0.2);
}
.plan-form-modal-cancel-btn {
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}
.plan-form-modal-cancel-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}
.plan-form-modal-save-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #5589F2 0%, #446AE8 100%);
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}
.plan-form-modal-save-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(85, 137, 242, 0.4);
}

.keyword-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
}

.keyword-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.keyword-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 600px;
  max-height: 80vh;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
  z-index: 1001;
}

.keyword-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.keyword-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.keyword-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 28px;
  cursor: pointer;
}

.keyword-modal-body {
  height: 350px;
  display: flex;
  flex-direction: column;
}

.monitor-plan-info {
  display: flex;
  gap: 24px;
  padding: 14px 16px;
  background: rgba(11, 27, 88, 0.5);
  border: 1px solid rgba(76, 165, 255, 0.15);
  border-radius: 4px;
  margin-bottom: 14px;
}

.plan-info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.plan-info-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.plan-info-value {
  font-size: 13px;
  color: #fff;
  font-weight: 500;
}

.plan-status {
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.plan-status.active {
  background: rgba(0, 212, 170, 0.2);
  color: #00D4AA;
  border: 1px solid rgba(0, 212, 170, 0.3);
}

.plan-status.inactive {
  background: rgba(255, 100, 100, 0.2);
  color: #ff6464;
  border: 1px solid rgba(255, 100, 100, 0.3);
}

.keyword-modal-table-header {
  display: flex;
  padding: 12px 16px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px 4px 0 0;
}

.keyword-modal-table-scroll {
  flex: 1;
  overflow-y: auto;
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-top: none;
  border-radius: 0 0 4px 4px;
}

.keyword-modal-table-header span {
  flex: 1;
  text-align: center;
  font-weight: 600;
  color: #fff;
  font-size: 14px;
}

.keyword-detail-link {
  display: inline-block;
  margin-left: 12px;
  padding: 4px 10px;
  background: rgba(255, 100, 100, 0.15);
  border: 1px solid rgba(255, 100, 100, 0.3);
  border-radius: 4px;
  font-size: 12px;
  color: #ff6464;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-detail-link:hover {
  background: rgba(255, 100, 100, 0.25);
  border-color: rgba(255, 100, 100, 0.5);
}

.negative-keyword-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
}

.negative-keyword-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.negative-keyword-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 700px;
  max-height: 70vh;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
  z-index: 1001;
}

.negative-keyword-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.2);
}

.negative-keyword-modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}

.negative-keyword-modal-close {
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 24px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px;
}

.negative-keyword-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.negative-keyword-modal-body {
  max-height: calc(70vh - 100px);
  overflow-y: auto;
}

.negative-keyword-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.negative-keyword-item {
  padding: 8px 16px;
  background: linear-gradient(135deg, rgba(255, 100, 100, 0.15) 0%, rgba(255, 100, 100, 0.08) 100%);
  border: 1px solid rgba(255, 100, 100, 0.3);
  border-radius: 4px;
  font-size: 13px;
  color: #ff6464;
}

.negative-keyword-modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid rgba(76, 165, 255, 0.2);
}

.negative-keyword-modal-close-btn {
  padding: 8px 24px;
  background: rgba(76, 165, 255, 0.2);
  border: 1px solid rgba(76, 165, 255, 0.4);
  border-radius: 4px;
  color: #4ca5ff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.negative-keyword-modal-close-btn:hover {
  background: rgba(76, 165, 255, 0.3);
  border-color: rgba(76, 165, 255, 0.6);
}

.keyword-modal-table-header span:last-child {
  flex: 0.8;
}

.keyword-modal-table-body {
  padding: 0;
}

.keyword-modal-table-row {
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
  align-items: center;
  justify-content: center;
  background: rgba(11, 27, 88, 0.52);
}

.keyword-modal-table-row.keyword-disabled {
  opacity: 0.5;
}

.keyword-modal-table-row:last-child {
  border-bottom: none;
}

.keyword-modal-table-row > span {
  flex: 1;
  text-align: center;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.keyword-modal-table-row > span:last-child {
  flex: 0.8;
}

.keyword-modal-table-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.keyword-modal-table-actions a {
  color: #4cd9ff;
  text-decoration: none;
  font-size: 13px;
}

.keyword-modal-table-actions a:hover {
  text-decoration: underline;
}

.keyword-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.keyword-modal-add-btn {
  padding: 8px 0;
  flex: 1;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-modal-add-btn:hover {
  border-color: #4cd9ff;
  background: rgba(76, 217, 255, 0.1);
}

.export-modal {
  position: fixed;
  inset: 0;
  z-index: 1004;
}

.export-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.export-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 480px;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
}

.export-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.export-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.export-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
}

.export-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.export-modal-body {
  padding: 8px 0;
}

.export-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.export-form-item:last-child {
  margin-bottom: 0;
}

.export-form-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  min-width: 80px;
  flex-shrink: 0;
}

.export-date-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.export-date-input {
  padding: 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  outline: none;
}

.export-date-input:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.export-date-input:focus {
  border-color: #4cd9ff;
  box-shadow: 0 0 0 2px rgba(76, 217, 255, 0.2);
}

.date-separator {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.export-select {
  flex: 1;
  padding: 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  cursor: pointer;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(255,255,255,0.6)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
}

.export-select:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.export-select:focus {
  border-color: #4cd9ff;
  box-shadow: 0 0 0 2px rgba(76, 217, 255, 0.2);
}

.export-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.export-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.export-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.export-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.export-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.tip-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
}

.tip-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.tip-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
}

.tip-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.tip-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.tip-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
}

.tip-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.tip-modal-body {
  padding: 8px 0;
}

.tip-modal-message {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
}

.tip-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.tip-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.tip-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.confirm-modal {
  position: fixed;
  inset: 0;
  z-index: 1002;
}

.confirm-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.confirm-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 500px;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
}

.confirm-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.confirm-modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.confirm-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
}

.confirm-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.confirm-modal-body {
  padding: 8px 0;
}

.confirm-modal-info {
  background: rgba(11, 27, 88, 0.52);
  border-radius: 6px;
  padding: 16px;
}

.confirm-info-item {
  display: flex;
  margin-bottom: 12px;
  align-items: flex-start;
}

.confirm-info-item:last-child {
  margin-bottom: 0;
}

.confirm-info-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  min-width: 70px;
  flex-shrink: 0;
}

.confirm-info-value {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  flex: 1;
  word-break: break-all;
}

.confirm-select {
  flex: 1;
  padding: 8px 12px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  cursor: pointer;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(255,255,255,0.6)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
}

.confirm-select:hover {
  border-color: rgba(76, 165, 255, 0.5);
}

.confirm-select:focus {
  border-color: #4cd9ff;
  box-shadow: 0 0 0 2px rgba(76, 217, 255, 0.2);
}

.confirm-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.confirm-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.confirm-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.confirm-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #E53F31 0%, #C0392B 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.confirm-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #F05F4F 0%, #D0493B 100%);
}

.keyword-edit-modal {
  position: fixed;
  inset: 0;
  z-index: 1002;
}

.keyword-edit-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.keyword-edit-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
  z-index: 1003;
}

.keyword-edit-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.keyword-edit-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.keyword-edit-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 28px;
  cursor: pointer;
}

.keyword-edit-modal-body {
  padding: 0;
}

.keyword-edit-form-item {
  margin-bottom: 16px;
}

.keyword-edit-form-item label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.86);
  font-weight: 500;
}

.keyword-edit-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  background: rgba(11, 27, 88, 0.52);
  color: rgba(255, 255, 255, 0.86);
}

.keyword-edit-input:focus {
  outline: none;
  border-color: #4cd9ff;
}

.keyword-edit-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.keyword-edit-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.keyword-edit-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-edit-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.keyword-edit-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-edit-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.keyword-batch-import-modal {
  position: fixed;
  inset: 0;
  z-index: 1003;
}

.keyword-batch-import-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
}

.keyword-batch-import-modal-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 500px;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
}

.keyword-batch-import-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.keyword-batch-import-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.keyword-batch-import-modal-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 28px;
  cursor: pointer;
}

.keyword-batch-import-modal-close:hover {
  color: #fff;
}

.keyword-batch-import-modal-body {
  padding: 0;
}

.batch-import-tip {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.72);
  margin-bottom: 12px;
}

.batch-import-textarea {
  width: 100%;
  height: 200px;
  padding: 12px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  resize: none;
  box-sizing: border-box;
}

.batch-import-textarea::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.keyword-batch-import-modal-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.keyword-batch-import-modal-cancel-btn {
  padding: 8px 24px;
  background: rgba(11, 27, 88, 0.52);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.keyword-batch-import-modal-cancel-btn:hover {
  background: rgba(17, 45, 132, 0.72);
}

.keyword-batch-import-modal-confirm-btn {
  padding: 8px 24px;
  background: linear-gradient(135deg, #4cd9ff 0%, #00b4d8 100%);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.keyword-batch-import-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #6ce5ff 0%, #00c8f0 100%);
}

.keyword-modal-import-btn {
  padding: 8px 0;
  flex: 1;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.3);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.keyword-modal-import-btn:hover {
  border-color: #4cd9ff;
  background: rgba(76, 217, 255, 0.1);
}

.warning-record {
  position: absolute;
  top: 28px;
  left: 486px;
  z-index: 3;
  width: 236px;
  padding: 12px 16px;
  box-sizing: border-box;
  background: rgba(11, 24, 112, 0.88);
  border: 1px solid rgba(82, 150, 255, 0.3);
}

.warning-record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.sentiment-detail-panel {
  position: fixed;
  top: 110px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1004;
  width: 80%;
  max-width: 1000px;
  max-height: 70vh;
}

.sentiment-detail-panel-dialog {
  padding: 18px 18px 16px;
  box-sizing: border-box;
}

.sentiment-detail-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.sentiment-detail-panel-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.sentiment-detail-panel-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 28px;
  cursor: pointer;
}

.sentiment-detail-panel-body {
  padding: 16px;
  background: rgba(11, 27, 88, 0.52);
  border-radius: 4px;
  max-height: calc(85vh - 80px);
  overflow-y: auto;
}

.sentiment-detail-header {
  text-align: center;
  margin-bottom: 16px;
}

.sentiment-detail-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.sentiment-detail-info {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.info-item {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.86);
}

.info-label {
  color: rgba(255, 255, 255, 0.5);
  margin-right: 4px;
}

.sentiment-detail-url {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.18);
}

.url-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin-right: 8px;
}

.url-link {
  font-size: 14px;
  color: #4cd9ff;
  text-decoration: none;
  word-break: break-all;
}

.url-link:hover {
  text-decoration: underline;
}

.sentiment-detail-propagation {
  margin-top: 12px;
  text-align: right;
}

.propagation-btn {
  padding: 6px 16px;
  background: rgba(76, 217, 255, 0.2);
  border: 1px solid rgba(76, 217, 255, 0.5);
  border-radius: 4px;
  color: #4cd9ff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.propagation-btn:hover {
  background: rgba(76, 217, 255, 0.3);
  border-color: #4cd9ff;
}

.sentiment-detail-content {
  margin-top: 16px;
}

.content-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 8px;
}

.content-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.86);
  line-height: 1.8;
  padding: 12px;
  background: rgba(3, 10, 69, 0.92);
  border: 1px solid rgba(76, 165, 255, 0.18);
  border-radius: 4px;
  min-height: 200px;
}

.supervision-warning-item {
  cursor: pointer;
  transition: all 0.3s;
}

.supervision-warning-item:hover {
  background: rgba(65, 100, 200, 0.45);
}

.propagation-modal {
  position: fixed;
  inset: 0;
  z-index: 1005;
  display: flex;
  align-items: center;
  justify-content: center;
}

.propagation-modal-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
}

.propagation-modal-dialog {
  position: relative;
  width: 90%;
  max-width: 700px;
  max-height: 85vh;
  z-index: 1006;
  display: flex;
  flex-direction: column;
  padding: 18px;
  box-sizing: border-box;
}

.propagation-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.2);
}

.propagation-modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
}

.propagation-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(76, 165, 255, 0.2);
}

.propagation-modal-close {
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 24px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px;
}

.propagation-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.propagation-modal-body {
  padding: 16px;
  background: rgba(3, 10, 69, 0.95);
  border-radius: 6px;
  max-height: calc(85vh - 120px);
  overflow-y: auto;
}

.propagation-modal-body::-webkit-scrollbar {
  width: 6px;
}

.propagation-modal-body::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}

.propagation-modal-body::-webkit-scrollbar-thumb {
  background: rgba(76, 217, 255, 0.3);
  border-radius: 3px;
}

.propagation-modal-body::-webkit-scrollbar-thumb:hover {
  background: rgba(76, 217, 255, 0.5);
}

.propagation-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.propagation-item-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}

.propagation-item {
  background: linear-gradient(135deg, rgba(11, 27, 88, 0.6) 0%, rgba(11, 27, 88, 0.4) 100%);
  border: 1px solid rgba(76, 165, 255, 0.2);
  border-radius: 6px;
  padding: 12px 16px;
  transition: all 0.3s;
}

.propagation-item:hover {
  border-color: rgba(76, 217, 255, 0.4);
  box-shadow: 0 2px 12px rgba(76, 217, 255, 0.15);
}

.propagation-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.propagation-type {
  flex-shrink: 0;
}

.type-label {
  padding: 5px 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  min-width: 50px;
  text-align: center;
}

.type-original {
  background: linear-gradient(135deg, rgba(0, 212, 170, 0.25) 0%, rgba(0, 212, 170, 0.15) 100%);
  color: #00D4AA;
  border: 1px solid rgba(0, 212, 170, 0.3);
}

.type-repost {
  background: linear-gradient(135deg, rgba(85, 137, 242, 0.25) 0%, rgba(85, 137, 242, 0.15) 100%);
  color: #5589F2;
  border: 1px solid rgba(85, 137, 242, 0.3);
}

.type-comment {
  background: linear-gradient(135deg, rgba(76, 217, 255, 0.25) 0%, rgba(76, 217, 255, 0.15) 100%);
  color: #4cd9ff;
  border: 1px solid rgba(76, 217, 255, 0.3);
}

.type-quote {
  background: linear-gradient(135deg, rgba(255, 166, 0, 0.25) 0%, rgba(255, 166, 0, 0.15) 100%);
  color: #FFA600;
  border: 1px solid rgba(255, 166, 0, 0.3);
}

.propagation-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  gap: 12px;
}

.info-source {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 500;
}

.info-date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  white-space: nowrap;
}

.arrow-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(76, 217, 255, 0.5);
  font-size: 18px;
  line-height: 1;
  padding: 6px 0;
  transition: all 0.3s;
}

.arrow-separator:hover {
  color: rgba(76, 217, 255, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/pages/sentiment-surveillance.vue